/**
 * Horarios de negocio Oh Belleza: Colombia (America/Bogota, UTC-5).
 *
 * Backend guarda DATETIME MySQL como UTC sin zona (`YYYY-MM-DD HH:MM:SS`).
 * Sin `Z`, `new Date(...)` lo trata como hora local del navegador → desfase.
 * Aquí interpretamos ese formato como UTC y mostramos siempre en Bogotá.
 */

const TZ = 'America/Bogota';
const LOCALE = 'es-CO';

const MYSQL_UTC_RE = /^(\d{4})-(\d{2})-(\d{2})[ T](\d{2}):(\d{2}):(\d{2})(\.\d+)?$/;

/** @param {unknown} value @returns {Date|null} */
export function parseInstant(value) {
  if (value == null || value === '') return null;
  if (value instanceof Date) {
    return Number.isNaN(value.getTime()) ? null : value;
  }
  if (typeof value === 'number' && Number.isFinite(value)) {
    const ms = value < 1e12 ? value * 1000 : value;
    const d = new Date(ms);
    return Number.isNaN(d.getTime()) ? null : d;
  }
  const s = String(value).trim();
  if (!s || s === 'Invalid Date' || s === 'null' || s === 'undefined') return null;

  // Ya trae zona (Z u offset) → Date nativo.
  if (/[zZ]$|[+-]\d{2}:?\d{2}$/.test(s) || /T.*[+-]\d{2}:\d{2}/.test(s)) {
    const d = new Date(s);
    return Number.isNaN(d.getTime()) ? null : d;
  }

  // MySQL DATETIME / ISO sin zona: convención del API = UTC.
  const m = s.match(MYSQL_UTC_RE);
  if (m) {
    const ms = Date.UTC(
      Number(m[1]),
      Number(m[2]) - 1,
      Number(m[3]),
      Number(m[4]),
      Number(m[5]),
      Number(m[6]),
      m[7] ? Math.round(Number(`0${m[7]}`) * 1000) : 0
    );
    const d = new Date(ms);
    return Number.isNaN(d.getTime()) ? null : d;
  }

  const d = new Date(s);
  return Number.isNaN(d.getTime()) ? null : d;
}

/**
 * @param {unknown} value
 * @param {Intl.DateTimeFormatOptions} [opts]
 */
export function formatColombia(value, opts = {}) {
  const d = parseInstant(value);
  if (!d) return '—';
  return d.toLocaleString(LOCALE, { timeZone: TZ, ...opts });
}

export function formatColombiaDateTime(value) {
  return formatColombia(value, { dateStyle: 'short', timeStyle: 'medium' });
}

export function formatColombiaTime(value) {
  return formatColombia(value, { hour: '2-digit', minute: '2-digit' });
}

/** Edad relativa a partir del instante parseado (UTC-aware). */
export function formatHace(value) {
  const d = parseInstant(value);
  if (!d) return null;
  const mins = Math.floor((Date.now() - d.getTime()) / 60000);
  if (mins < 0) return 'hace segundos';
  if (mins < 1) return 'hace segundos';
  if (mins === 1) return 'hace 1 min';
  if (mins < 60) return `hace ${mins} min`;
  const h = Math.floor(mins / 60);
  const m = mins % 60;
  if (h < 24) return m ? `hace ${h}h ${m}m` : `hace ${h}h`;
  return `hace ${Math.floor(h / 24)}d`;
}

export const COLOMBIA_TZ = TZ;
